import { useCallback, useEffect } from 'react';

type UseCloseOnEscapeProps = {
	onClose?: () => void;
	enabled?: boolean;
	preventDefault?: boolean;
};

const isEscapeKey = ( e: KeyboardEvent ) => e.key === 'Escape';

const useCloseOnEscape = ( { onClose, enabled = true, preventDefault = true }: UseCloseOnEscapeProps ) => {
	const onKeyDown = useCallback( ( e: KeyboardEvent ) => {
		if ( !isEscapeKey( e ) ) { return; }

		if ( preventDefault ) { e.preventDefault(); }
		onClose?.();
	}, [ onClose, preventDefault ] );

	useEffect( () => {
		if ( !enabled ) { return () => {}; }

		document.addEventListener( 'keydown', onKeyDown );

		return () => {
			document.removeEventListener( 'keydown', onKeyDown );
		};
	}, [ onKeyDown, enabled ] );
};

export default useCloseOnEscape;
